import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

import { VersionsViewService } from '@app/services/app/versions.service';

import * as Objects from '@core/objects';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';


@Component({
    selector: 'project-details-breadcrumb-version-header',
    templateUrl: './breadcrumb-version-header.component.html',
    styleUrls: ['./breadcrumb-version-header.component.scss']
})
export class ProjectDetailsBreadcrumbVersionHeaderComponent implements OnInit, OnChanges {
    public readonly MODAL_PENDING_CHANGES = "modal_tags_pending_changes";
    public readonly MODAL_NONE = "modal_none";
    public readonly MODAL_LABELS_UPDATE_ERROR = "modal_tags_save_error";

	@Input() project: Objects.Request = null;
    @Input() version: Objects.Version = null;
    @Input() exclude: Array<Objects.Label> = []; // those are the tags that don't go after + under header
	@Input() title: string = '';
	@Input() breadcrumbs: any = [];
	@Input() menu: Array<ThreeDotsMenuItem> = [];
    @Output() action = new EventEmitter<string>();
    @Output() statusAction = new EventEmitter<Objects.Status>();

    public edit: boolean = false;
    public editorLabels: Array<Objects.Label>;
    public freezed: boolean = false;
    public pendingChanges: boolean = false;
    public modalView: string = this.MODAL_NONE;

    public diffLabels: Array<Objects.Label> = [];
    public alertText: string = 'Changing the tags of an artwork can remove it from the project view.';

    constructor( private versionsSrv: VersionsViewService) { }


    ngOnInit() {
        // Here we do nothing by now.

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.project || changes.version || changes.exclude){
            this.updateDiffLabels();
        }
    }

    private updateDiffLabels() {
        if(this.version == null || this.exclude == null)
            return;
        this.diffLabels = this.version.labels.filter((label: Objects.Label) => !this.exclude.some((l) => l.id == label.id));
    }


    onModalExitEdition() {
        this.edit = false;
        this.modalView = this.MODAL_NONE;
        this.resetEditorLabels()
    }

    onModalCancel() {
        this.modalView = this.MODAL_NONE;
    }

    onModalErrorDismiss() {
        this.modalView = this.MODAL_NONE;
        if (this.freezed) {
            this.freezed = false;
            this.resetEditorLabels();
        }
    }


    toggleEdit() {
        // when toggle edit, if we have pending changes, we show the modal
        if (this.edit && this.pendingChanges) {
            this.modalView = this.MODAL_PENDING_CHANGES;
            return;
        }
        // if no changes pending, we just toggle edit mode
        this.edit = !this.edit;
    }

    onMenuSelect(key: string) {
        if (key == 'edit') {
            this.toggleEdit();
            return;
        }
        this.action.emit(key);
    }

    onStatusMenuSelect(status: Objects.Status){
        this.statusAction.emit(status);
    }

    setLabels(labels: Array<Objects.Label>) {
        this.editorLabels = labels;
        this.pendingChanges = true;
    }

    onTagsConfirm() {
        this.freezed = true;
        this.versionsSrv.setLabels(this.editorLabels);
        this.pendingChanges = false;
    }


    protected resetEditorLabels() {
        // reset labels if we are exiting edit mode to be all again when back
        if (!this.edit) {
            this.editorLabels = this.project.labels;
            this.pendingChanges = false;
        }
    }


}
